import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import className from 'classnames/bind';
import styles from './index.module.sass';
import LicensePlateItem from 'feature/license-plates/license-plate-item';
import LicensePlateDialog from './license-plate-dialog';
import Icon from 'components/icon';
import PageLayout from 'layout/page';
import { useAppContext } from 'use-app';
import {
  useLicensePlateContext,
  SET_SERVICE_DIALOG,
  SELECT_LICENSE_PLATE,
} from 'feature/license-plates/use-license-plate';
import Info from 'components/info';
import iconReport from 'assets/icon_report.svg';
import ButtonDialog from 'components/button-dialog';
import { PATH } from 'config';
import { getUserInfo } from 'helpers/data-check-helper';
import emptyPlate from 'assets/empty-plate.svg';
import EmptyState from 'components/empty-state';
const cx = className.bind(styles);

const LicensePlates = () => {
  const { state: appState } = useAppContext();
  const { state, dispatch } = useLicensePlateContext();
  const { hasPayments, hasLicensePlates } = getUserInfo(appState);
  const history = useHistory();
  const location = useLocation();
  let licensePlates = [appState.licensePlates][0] || [];
  let allPlateTypes = licensePlates.map(plate => plate.vehicleType);
  let hasMoto = allPlateTypes.includes('moto');

  const licensePlatesContentClasses = cx({
    'license-plates-layout': true,
    'show-moto-hint': hasMoto,
  });

  const serviceDialogOpen = () => {
    dispatch({
      type: SET_SERVICE_DIALOG,
      payload: true,
    });
  };
  const serviceDialogClose = () => {
    dispatch({
      type: SET_SERVICE_DIALOG,
      payload: false,
    });
  };

  const CreditCardAlter = () => {
    if (!hasPayments && hasLicensePlates) {
      return (
        <Info
          onClick={() => {
            history.push(PATH.MOCHIPAY_FLOW_CREDIT_CARD);
          }}
          withArrow={true}
          customStyle={{ margin: '-30px -24px 20px' }}
        >
          請完成付款設定，才能使用加油停車付款服務
        </Info>
      );
    }

    return <></>;
  };

  const NeedHelp = () => {
    return (
      <div className={styles['service-hint']} onClick={serviceDialogOpen}>
        需要幫忙嗎
        <Icon imgSrc={iconReport} height="14px" alt="icon-report" />
      </div>
    );
  };

  const selectPlateNumber = licensePlate => {
    dispatch({ type: SELECT_LICENSE_PLATE, payload: licensePlate });
  };

  const Content = () => {
    if (licensePlates.length === 0) {
      return (
        <div className={styles['license-plates-none']}>
          <EmptyState fullText="無新增車牌" icon={emptyPlate} />
          <div className={styles.hint}>
            新增車牌
            <a style={{ textDecoration: 'underline' }} href="iknow99://app/autopass/license-plates">
              請點此至愛車 99 APP
            </a>{' '}
            內完成。
          </div>
        </div>
      );
    }

    return (
      <div className={styles['license-plates-list']}>
        {licensePlates.map(licensePlate => {
          return (
            <LicensePlateItem
              withoutEditButton={true}
              key={licensePlate.id}
              licensePlate={licensePlate}
              onClick={() => selectPlateNumber(licensePlate)}
            />
          );
        })}
        <div className={styles.hint}>
          若要新增/停用車牌
          <a style={{ textDecoration: 'underline' }} href="iknow99://app/autopass/license-plates">
            請點此至愛車 99 APP
          </a>{' '}
          內完成。
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.page}>
        <PageLayout>
          <CreditCardAlter />
          <div className={licensePlatesContentClasses}>
            <div className={styles['license-plates']}>
              <Content />
              <LicensePlateDialog
                isShow={state.showDialog}
                licensePlate={state.selectedLicensePlate}
                withoutEditButton
              />
            </div>
            <NeedHelp />
          </div>
        </PageLayout>
      </div>

      <ButtonDialog
        isShow={state.serviceDialog}
        title="選擇需要的協助"
        items={[
          {
            content: '新增更多車牌',
            theme: 'positive',
            onClick: () => {
              serviceDialogClose();
              history.push({
                pathname: PATH.CONTACT,
                state: { from: location.pathname, issueGroupKey: 'Account', issueKey: 'Account::AddMorePlate' },
              });
            },
          },
          {
            content: '車牌已被他人綁定',
            theme: 'positive',
            onClick: () => {
              serviceDialogClose();
              history.push({
                pathname: PATH.CONTACT,
                state: { from: location.pathname, issueGroupKey: 'Account', issueKey: 'Account::PlateIsAlreadyBinded' },
              });
            },
          },
          {
            content: '其他問題',
            theme: 'positive',
            onClick: () => {
              serviceDialogClose();
              history.push({
                pathname: PATH.CONTACT,
                state: { from: location.pathname, issueGroupKey: 'Account' },
              });
            },
          },
          {
            content: '取消',
            theme: 'cancel',
            onClick: serviceDialogClose,
          },
        ]}
      />
    </>
  );
};

export default LicensePlates;
